// @flow
import type {Action} from '../../../state/types'

export type SetServiceProvidersPayload = {
  serviceProviders: ServiceProvider[],
}

const id = 'map/SET_SERVICE_PROVIDERS'

export const setServiceProviders = (serviceProviders: ServiceProvider[]): Action<SetServiceProvidersPayload> => ({
  type: id,
  payload: {
    serviceProviders,
  }
})

setServiceProviders.id = id
